import React, { useEffect, useState } from "react";
import { Box, Grid, Card } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet";
import moment from 'moment-timezone';
import Button from '@mui/material/Button';
import LensIcon from '@mui/icons-material/Lens';
import db from "../../firebase-config";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

const isExpiredTimestamp = (timestamp, limitMin = 60) => {
    if (!timestamp || typeof timestamp !== "string") return true;

    const parsed = new Date(timestamp.replace(" ", "T"));
    if (isNaN(parsed.getTime())) return true;

    const now = new Date();
    const diffMin = (now - parsed) / 1000 / 60;

    return diffMin > limitMin;
};



export default function StatusMachine() {
    const [statusMachine, setStatusMachine] = useState([]);
    const [oeeDashboard, setOeeDashboard] = useState([]);

    const today = new Date();
    const hourago = new Date(today.getTime());
    const tag_timestr = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
    const timestr = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD');


    useEffect(() => {
        const today = moment().format("YYYY-MM-DD");
        const oeeSubscribe = db
            .collection("prod_mes_ignition_nongjok_oee")
            .onSnapshot((querySnapshot) => {
                const oeeDocs = [];

                querySnapshot.forEach((doc) => {
                    const data = { ...doc.data(), id: doc.id };
                    if (doc.id.includes(`4046_CURRENT_OEE_${today}`)) {
                        oeeDocs.push(data);
                    }
                });
                const lastOee = oeeDocs[oeeDocs.length - 1];

                if (lastOee) {
                    setOeeDashboard(lastOee);
                } else {
                    setOeeDashboard([]);
                }

            });

        const subscriberStatusMachine = db
            .collection("prod_mes_ignition_nongjok_tag_list")
            .onSnapshot((querySnapshot) => {
                const statusMachineData = querySnapshot.docs.map(doc => ({
                    ...doc.data(),
                    id: doc.id,
                }));
                setStatusMachine(statusMachineData);
            });
        return () => {
            oeeSubscribe();
            subscriberStatusMachine();
        }
    }, []);

    const materials = oeeDashboard?.PO
        ? Object.entries(oeeDashboard.PO).map(([code, detail]) => ({
            code,
            ...detail,
        }))
        : [];

    const findTAG = (key) =>
        statusMachine?.find(item => item?.TAG?.includes(key)) || null;

    const line01PO = findTAG("MESNJ.4046.Thailand.FGWMS.Line01.PO_NO")?.VALUE;
    const line02PO = findTAG("MESNJ.4046.Thailand.FGWMS.Line02.PO_NO")?.VALUE;

    const line01Qty = Number(
        findTAG("MESNJ.4046.Thailand.FGWMS.Line01.SUMQTY")?.VALUE || 0
    );
    const line02Qty = Number(
        findTAG("MESNJ.4046.Thailand.FGWMS.Line02.SUMQTY")?.VALUE || 0
    );

    const normalizePO = (po) => {
        if (po == null) return null;

        const s = String(po).trim();

        // ตัด "00" หน้า เฉพาะกรณียาวเกิน 10 ตัว
        if (s.length > 10 && s.startsWith("00")) {
            return s.slice(2);
        }

        return s;
    };

    const normLine01PO = normalizePO(line01PO);
    const normLine02PO = normalizePO(line02PO);

    const materialsWithSumQty = materials.flatMap(material => {
        const poCode = normalizePO(material.code);

        const matchLine01 = poCode === normLine01PO;
        const matchLine02 = poCode === normLine02PO;

        if (matchLine01 && matchLine02) {
            return [{
                ...material,
                originalCode: material.code,
                code: poCode,
                totalQty: line01Qty + line02Qty,
                lines: ["Line01", "Line02"],
                type: "MERGED",
            }];
        }

        if (matchLine01) {
            return [{
                ...material,
                originalCode: material.code,
                code: poCode,
                totalQty: line01Qty,
                line: "Line01",
                type: "SINGLE",
            }];
        }

        if (matchLine02) {
            return [{
                ...material,
                originalCode: material.code,
                code: poCode,
                totalQty: line02Qty,
                line: "Line02",
                type: "SINGLE",
            }];
        }

        return [{
            ...material,
            originalCode: material.code,
            code: poCode,
            totalQty: 0,
            type: "NO_MATCH",
        }];
    });

    const gettime_basket = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.RMWMS.AutoLine.TotalActual Weight"));

    const getColorBasket = () => {
        try {
            if (
                gettime_basket?.IS_CONNECTED === false ||
                isExpiredTimestamp(gettime_basket?.TAG_TIMESTAMP)
            ) {
                return "#9e9e9e"; // เทา
            }

            const diffMin =
                (new Date() -
                    new Date(gettime_basket.TAG_TIMESTAMP.replace(" ", "T"))) /
                1000 /
                60;

            if (diffMin <= 5) return "#4caf50"; // เขียว
            return "#f7ec4d"; // เหลือง
        } catch {
            return "#9e9e9e";
        }
    };

    const get_grinder = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Prep.Grinder_RUN"));

    const getColorGrinder = () => {
        let color;
        try {
            if (get_grinder?.IS_CONNECTED == false || isExpiredTimestamp(get_grinder?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_grinder?.IS_CONNECTED == true && get_grinder?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_grinder?.IS_CONNECTED == true && get_grinder?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_silo1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Silo1.RunOn"));

    const getColorSilo1 = () => {
        let color;
        try {
            if (get_silo1?.IS_CONNECTED == false || isExpiredTimestamp(get_silo1?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_silo1?.IS_CONNECTED == true && get_silo1?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_silo1?.IS_CONNECTED == true && get_silo1?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_silo2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Silo2.RunOn"));

    const getColorSilo2 = () => {
        let color;
        try {
            if (get_silo2?.IS_CONNECTED == false || isExpiredTimestamp(get_silo2?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_silo2?.IS_CONNECTED == true && get_silo2?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_silo2?.IS_CONNECTED == true && get_silo2?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_silo3 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Silo3.RunOn"));

    const getColorSilo3 = () => {
        let color;
        try {
            if (get_silo3?.IS_CONNECTED == false || isExpiredTimestamp(get_silo3?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_silo3?.IS_CONNECTED == true && get_silo3?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_silo3?.IS_CONNECTED == true && get_silo3?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_silo4 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Silo4.RunOn"));

    const getColorSilo4 = () => {
        let color;
        try {
            if (get_silo4?.IS_CONNECTED == false || isExpiredTimestamp(get_silo4?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_silo4?.IS_CONNECTED == true && get_silo4?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_silo4?.IS_CONNECTED == true && get_silo4?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_silo5 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Silo5.RunOn"));

    const getColorSilo5 = () => {
        let color;
        try {
            if (get_silo5?.IS_CONNECTED == false || isExpiredTimestamp(get_silo5?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_silo5?.IS_CONNECTED == true && get_silo5?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_silo5?.IS_CONNECTED == true && get_silo5?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_mixer1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.MIXER1.Status"));

    const getColorMixer1 = () => {
        let color;
        try {
            if (get_mixer1?.IS_CONNECTED == false || isExpiredTimestamp(get_mixer1?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_mixer1?.IS_CONNECTED == true && get_mixer1?.VALUE == 3) {
                color = "#4caf50"
            } else if (get_mixer1?.IS_CONNECTED == true && get_mixer1?.VALUE != 3) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_mixer2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.MIXER2.Mixing"));

    const getColorMixer2 = () => {
        let color;
        try {
            if (get_mixer2?.IS_CONNECTED == false || isExpiredTimestamp(get_mixer2?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_mixer2?.IS_CONNECTED == true && get_mixer2?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_mixer2?.IS_CONNECTED == true && get_mixer2?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_emultion = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Emul.RunOn"));

    const getColorEmultion = () => {
        let color;
        try {
            if (get_emultion?.IS_CONNECTED == false || isExpiredTimestamp(get_emultion?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_emultion?.IS_CONNECTED == true && get_emultion?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_emultion?.IS_CONNECTED == true && get_emultion?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_stuffer1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Stuffer1.State"));

    const getColorStuffer1 = () => {
        let color;
        try {
            if (get_stuffer1?.IS_CONNECTED == false || isExpiredTimestamp(get_stuffer1?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_stuffer1?.IS_CONNECTED == true && get_stuffer1?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_stuffer1?.IS_CONNECTED == true && get_stuffer1?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_stuffer3 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Stuffer3.State"));

    const getColorStuffer3 = () => {
        let color;
        try {
            if (get_stuffer3?.IS_CONNECTED == false || isExpiredTimestamp(get_stuffer3?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_stuffer3?.IS_CONNECTED == true && get_stuffer3?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_stuffer3?.IS_CONNECTED == true && get_stuffer3?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_con1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Cooking.Speed1"));
    const get_con2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Cooking.Speed2"));

    const get_cooking1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Cooking.Run1"));

    const getColorCooking1 = () => {
        let color;
        try {
            if (get_cooking1?.IS_CONNECTED == false || isExpiredTimestamp(get_cooking1?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_cooking1?.IS_CONNECTED == true && get_cooking1?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_cooking1?.IS_CONNECTED == true && get_cooking1?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_cooking2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Cooking.Run2"));

    const getColorCooking2 = () => {
        let color;
        try {
            if (get_cooking2?.IS_CONNECTED == false || isExpiredTimestamp(get_cooking2?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_cooking2?.IS_CONNECTED == true && get_cooking2?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_cooking2?.IS_CONNECTED == true && get_cooking2?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_packing1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Packing1.SYS_RUNNING_FLAG"));

    const getColorPacking1 = () => {
        let color;
        try {
            if (get_packing1?.IS_CONNECTED == false || isExpiredTimestamp(get_packing1?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_packing1?.IS_CONNECTED == true && get_packing1?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_packing1?.IS_CONNECTED == true && get_packing1?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_packing2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Packing2.SYS_RUNNING_FLAG"));

    const getColorPacking2 = () => {
        let color;
        try {
            if (get_packing2?.IS_CONNECTED == false || isExpiredTimestamp(get_packing2?.TAG_TIMESTAMP)) {
                color = "#9e9e9e"
            } else if (get_packing2?.IS_CONNECTED == true && get_packing2?.VALUE == 1) {
                color = "#4caf50"
            } else if (get_packing2?.IS_CONNECTED == true && get_packing2?.VALUE == 0) {
                color = "#f7ec4d"
            }
            return color;
        }
        catch {
            console.log()
        }
    }

    const get_tmf1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Packing1.RP_CYCLES_PER_MIN"));
    const get_tmf2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.Packing2.RP_CYCLES_PER_MIN"));

    const gettime_total1 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.FGWMS.Line01.SUMQTY"));

    const getColorTotal1 = () => {
        try {
            if (
                gettime_total1?.IS_CONNECTED === false ||
                isExpiredTimestamp(gettime_total1?.TAG_TIMESTAMP, 60)
            ) {
                return "#9e9e9e"; // เทา
            }

            const diffMin =
                (new Date() -
                    new Date(gettime_total1.TAG_TIMESTAMP.replace(" ", "T"))) /
                1000 /
                60;

            if (diffMin <= 5) return "#4caf50"; // เขียว
            return "#f7ec4d"; // เหลือง
        } catch {
            return "#9e9e9e";
        }
    };


    const gettime_total2 = statusMachine.find((user) => user.TAG.includes("MESNJ.4046.Thailand.FGWMS.Line02.SUMQTY"));

    const getColorTotal2 = () => {
        try {
            if (
                gettime_total2?.IS_CONNECTED === false ||
                isExpiredTimestamp(gettime_total2?.TAG_TIMESTAMP, 60)
            ) {
                return "#9e9e9e";
            }

            const diffMin =
                (new Date() -
                    new Date(gettime_total2.TAG_TIMESTAMP.replace(" ", "T"))) /
                1000 /
                60;

            if (diffMin <= 5) return "#4caf50";
            return "#f7ec4d";
        } catch {
            return "#9e9e9e";
        }
    };


    return (
        <>
            <Helmet>
                <title>Status Machine | Dashboard Nongjok</title>
            </Helmet>
            <Grid
                container spacing={1}
                direction="row"
                alignItems="top"
                justifyContent="center"
                style={{ minHeight: '78vh', maxHeight: '200vh', flexGrow: 1, paddingLeft: 0, paddingTop: 0, paddingRight: 15 }}
            >

                <Grid id="Bottom-row" container spacing={1} style={{ position: "relative", top: "0px" }}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <img src={require('../../assets/img/status_machine.png')} alt='status_machine' height="110%" width="100%" />
                        <Button variant="contained" style={{ position: 'absolute', top: "4.5vw", left: "3vw", fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Basket</Button>
                        <LensIcon sx={{ color: getColorBasket() }} style={{ position: 'absolute', left: '4vw', top: '7.2vw', fontSize: '28px' }}>Basket</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: "10vw", left: "12.4vw", fontSize: 10, fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Grinder</Button>
                        <LensIcon sx={{ color: getColorGrinder() }} style={{ position: 'absolute', left: '13.8vw', top: '12.3vw', fontSize: '28px' }}>Grinder</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '5vw', left: '22vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Silo1</Button>
                        <LensIcon sx={{ color: getColorSilo1() }} style={{ position: 'absolute', left: '22.9vw', top: '7.2vw', fontSize: '28px' }}>Silo1</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '9vw', left: '22vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Silo2</Button>
                        <LensIcon sx={{ color: getColorSilo2() }} style={{ position: 'absolute', left: '22.9vw', top: '10.8vw', fontSize: '28px' }}>Silo2</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '12.3vw', left: '22vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Silo3</Button>
                        <LensIcon sx={{ color: getColorSilo3() }} style={{ position: 'absolute', left: '22.9vw', top: '14vw', fontSize: '28px' }}>Silo3</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '15.5vw', left: '22vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Silo4</Button>
                        <LensIcon sx={{ color: getColorSilo4() }} style={{ position: 'absolute', left: '22.9vw', top: '17.1vw', fontSize: '28px' }}>Silo4</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '18.7vw', left: '22vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Silo5</Button>
                        <LensIcon sx={{ color: getColorSilo5() }} style={{ position: 'absolute', left: '22.9vw', top: '20.4vw', fontSize: '28px' }}>Silo5</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '3.2vw', left: '28.3vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Mixer2</Button>
                        <LensIcon sx={{ color: getColorMixer2() }} style={{ position: 'absolute', left: '29.5vw', top: '5.5vw', fontSize: '28px' }}>Mixer2</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '10.7vw', left: '28.3vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Emultion</Button>
                        <LensIcon sx={{ color: getColorEmultion() }} style={{ position: 'absolute', left: '29.5vw', top: '12.5vw', fontSize: '28px' }}>Emulsion</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '20.8vw', left: '28.3vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Mixer1</Button>
                        <LensIcon sx={{ color: getColorMixer1() }} style={{ position: 'absolute', left: '29.5vw', top: '22.5vw', fontSize: '28px' }}>Mixer1</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '3.2vw', left: '33.8vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Stuffer1</Button>
                        <LensIcon sx={{ color: getColorStuffer1() }} style={{ position: 'absolute', left: '35vw', top: '5vw', fontSize: '28px' }}>Stuffer1</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '15.7vw', left: '33.8vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Stuffer3</Button>
                        <LensIcon sx={{ color: getColorStuffer3() }} style={{ position: 'absolute', left: '35vw', top: '17.5vw', fontSize: '28px' }}>Stuffer3</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '0.8vw', left: '43.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Con2  {get_con2?.IS_CONNECTED == true ? (Math.round((get_con2?.VALUE * 2.3) * 100) / 100).toFixed(2) : ' '} m/min</Button>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '8.3vw', left: '45.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Cooking1</Button>
                        <LensIcon sx={{ color: getColorCooking1() }} style={{ position: 'absolute', left: '46.5vw', top: '10.1vw', fontSize: '28px' }}>Cooking1</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '19vw', left: '45.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Cooking2</Button>
                        <LensIcon sx={{ color: getColorCooking2() }} style={{ position: 'absolute', left: '46.5vw', top: '21vw', fontSize: '28px' }}>Cooking2</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '23.8vw', left: '43.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Con1  {get_con1?.IS_CONNECTED == true ? (Math.round((get_con1?.VALUE * 2.3) * 100) / 100).toFixed(2) : ' '} m/min</Button>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '0.6vw', left: '59.8vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Packing2</Button>
                        <LensIcon sx={{ color: getColorPacking2() }} style={{ position: 'absolute', left: '61vw', top: '2.7vw', fontSize: '28px' }}>Packing2</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '4.8vw', left: '67.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Packing1</Button>
                        <LensIcon sx={{ color: getColorPacking1() }} style={{ position: 'absolute', left: '69vw', top: '7vw', fontSize: '28px' }}>Packing1</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '2.7vw', left: '80vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>TMF2 {get_tmf1?.IS_CONNECTED == true ? (Math.round(get_tmf1?.VALUE * 100) / 100).toFixed(2) : ' '} cycle/min</Button>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '7.9vw', left: '77.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>TMF1  {get_tmf2?.IS_CONNECTED == true ? (Math.round(get_tmf2?.VALUE * 100) / 100).toFixed(2) : ' '} cycle/min</Button>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '12.5vw', left: '82.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Total1</Button>
                        <LensIcon sx={{ color: getColorTotal1() }} style={{ position: 'absolute', left: '86.5vw', top: '14vw', fontSize: '28px' }}>Total1</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '12.5vw', left: '88vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>Total2</Button>
                        <LensIcon sx={{ color: getColorTotal2() }} style={{ position: 'absolute', left: '91.5vw', top: '14vw', fontSize: '28px' }}>Total2</LensIcon>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '17vw', left: '80.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>{gettime_total1?.IS_CONNECTED == true ? gettime_total1?.VALUE : ' '} Pack</Button>

                        <Button variant="contained" color="success" style={{ position: 'absolute', top: '17vw', left: '87.5vw', fontSize: '10px', fontWeight: 'bold', color: "#000000", background: '#e1f9fa', textTransform: 'none' }}>{gettime_total2?.IS_CONNECTED == true ? gettime_total2?.VALUE : ' '} Pack</Button>
                    </Grid>
                </Grid>

                <Grid id="Bottom-row" container spacing={1} style={{ position: "relative", top: "40px" }}>
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Card sx={{ bgcolor: "#ECF8F8", height: '220px' }}>
                            <Typography color="black" fontSize={'20px'} fontWeight="bold" align='left' sx={{ pt: 1, ml: 1 }}>
                                SKU Realtime
                            </Typography>
                            <TableContainer sx={{ minWidth: 100, minHeight: 100 }} aria-label="simple table">
                                <Table >
                                    <TableRow>
                                        <TableCell align="center" style={{ width: '10%', fontSize: 16, fontWeight: "bold" }}>PO</TableCell>
                                        <TableCell align="center" style={{ width: '25%', fontSize: 16, fontWeight: "bold" }}>SKU</TableCell>
                                        <TableCell align="center" style={{ width: '30%', fontSize: 16, fontWeight: "bold" }}>PLANTQTY</TableCell>
                                        <TableCell align="right" style={{ width: '12%', fontSize: 16, fontWeight: "bold" }}>ACTUALTY</TableCell>
                                    </TableRow>
                                    <TableBody>
                                        {materialsWithSumQty
                                            .filter(item => item.type !== "NO_MATCH")
                                            .map((item, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell align="center" sx={{ fontSize: 16, width: 80, py: 0, height: 40 }}>
                                                        {item.code}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ fontSize: 16, width: 140, py: 0, height: 40 }}>
                                                        {item.material_description}
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ fontSize: 16, py: 0, height: 40 }}>
                                                        {item.production_quantity}
                                                    </TableCell>
                                                    <TableCell align="right" sx={{ fontSize: 16, py: 0, height: 40 }}>
                                                        {item.totalQty}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
